import { useEffect, useState } from "react";
import { NestedCriteriaBuilder } from "../../PlatformParticipant/nested-builder/NestedCriteriaBuilder";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { toggleSidebarCollapse } from "../../../Redux/reducers/appSlice";
import { useNavigate, useParams } from "react-router-dom";
import { StyledHeader } from "../../Common/styles/header";
import { Typography, Divider, Box, CircularProgress } from "@mui/material";
import { useQuery } from "../../../utils/hooks";
import { AxiosResponse } from "axios";
import http from "../../../utils/http";
import { errorToastMessage } from "../../../utils/toast";
import BackButton from "../../Common/UI/BackButton";

const StudyCohortBuilder = () => {
  const dispatch = useAppDispatch();
  const { id: studyId, groupId } = useParams();
  const cohortName = useQuery().get("name") || "";
  const studyName = useAppSelector((state) => state.study.name);
  const [cohortData, setCohortData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response: AxiosResponse = await http.get(
          `/study/${studyId}/participant-groups/${groupId}`
        );
        const data = response.data?.data;
        const formattedData = data?.cohortQuery
          ? {
              ...data,
              dsl: data?.cohortQuery?.dsl,
              id: data?.cohortQuery?.id,
            }
          : null;
        setCohortData(formattedData);
        setLoading(false);
      } catch (error) {
        errorToastMessage(error as Error);
      } finally {
        setLoading(false);
      }
    };

    if (studyId && groupId) {
      fetchData();
    }
  }, [studyId, groupId]);

  useEffect(() => {
    dispatch(toggleSidebarCollapse(true));
    return () => {
      dispatch(toggleSidebarCollapse(false));
    };
  }, [dispatch]);
  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      <StyledHeader>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <BackButton onClick={handleBack} />
          <Typography variant="h2" color="text.primary">
            Criteria Filter
          </Typography>
        </Box>
      </StyledHeader>
      <Divider />
      <Box sx={{ height: "calc(100% - 73px)", overflow: "auto", p: 2 }}>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <NestedCriteriaBuilder
            type="study"
            studyId={studyId}
            studyName={studyName}
            cohortName={cohortName}
            groupId={groupId}
            cohortData={cohortData}
          />
        )}
      </Box>
    </>
  );
};

export default StudyCohortBuilder;
